import { mapActions, mapGetters, mapMutations } from 'vuex'
import general from '../general/index.vue'

export default {
  name: 'news-tags-dialog-view',
  data () {
    return {
      dialog: true,
      activeTab: 'general',
    }
  },
  components: {
    general
  },
  watch: {
    openDialogView () {
      this.dialog = this.openDialogView
    }
  },
  computed: {
    ...mapGetters({
      currentItem: 'newsTags/currentItem',
      openDialogView: 'newsTags/openDialogView',
      editId: 'newsTags/editId',
	  isLoading: 'newsTags/isLoading',
    }),
    tabs () {
      return [
        {
          name: 'General',
          slug: 'general',
          id: 1
        }
      ]
    }
  },
  created () {
    if (this.editId) {
      this.fetchItem()
    }
  },
  methods: {
    ...mapActions({
      fetchItem: 'newsTags/GET_LIST_ITEM'
    }),
    ...mapMutations({
      changeDialogView: 'newsTags/CHANGE_DIALOG_VIEW',
      changeEditId: 'newsTags/CHANGE_EDIT_ID',
      setContent: 'newsTags/SET_ITEM'
    }),
    changeCloseDialog () {
      this.dialog = false
      this.changeDialogView(false)
      this.changeEditId('')
    },

	save(){
	  this.$refs['general'].$emit('event-save');
	}
  },
  destroyed () {
    this.setContent(null)
  }
}
